import React, { useEffect, useState } from 'react';
import { Card, CardHeader, CardBody } from "reactstrap";
import { H4 } from "../../AbstractElements";
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import axios from "axios";
import { ServerPath } from "../../Constant";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const ChannelPerformance = () => {
    const [chartData, setChartData] = useState({
        labels: ['Referral', 'Digital Marketing', 'Campaign', 'Other'],
        datasets: [{
            label: 'Downloads',
            data: [0, 0, 0, 0],
            backgroundColor: ['#7366ef', '#48c3f3', '#4caf50', '#ff5252'],
            borderRadius: 4,
        }]
    });

    useEffect(() => {
        const fetchChannelData = async () => {
            try {
                const response = await axios.get(`${ServerPath}/referrals/channel-performance`);
                if (response.data.success) {
                    const data = response.data.data;
                    setChartData(prev => ({
                        ...prev,
                        datasets: [{
                            ...prev.datasets[0],
                            data: [data.referral, data.digitalMarketing, data.campaign, data.other]
                        }]
                    }));
                }
            } catch (error) {
                console.error("Error fetching channel performance:", error);
            }
        };
        
        fetchChannelData();
    }, []);

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { display: false },
        },
        scales: {
            y: { beginAtZero: true },
            x: { grid: { display: false } }
        }
    };

    return (
        <Card>
            <CardHeader>
                <H4>Channel Performance</H4>
            </CardHeader>
            <CardBody>
                <div style={{ height: '188px' }}>
                    <Bar data={chartData} options={options} />
                </div>
            </CardBody>
        </Card>
    );
};

export default ChannelPerformance;